// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Tw-z","smallCardRow":"Uw-z","largeCardRow":"Vw-z","productSearchRow":"Ww-z","curatedRow":"Xw-z"};